var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',[_c('v-circle',{ref:"arcFaceOne",attrs:{"config":_vm.config},on:{"click":_vm.onClick}}),_vm._l((_vm.conventions),function(convention,index){return _c('v-path',{key:index,attrs:{"config":convention}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }